/* Adds the visitor's country to every shipping related text (announcement bar, product page shipping
   line, cart progress). Most texts get the country FLAG after the text; the product page line names the
   COUNTRY in the visitor's language instead (no flag): "Gratis verzending naar Spanje vanaf €60".
   The country comes from the visitor's IP (Shopify's own /browsing_context_suggestions.json), never
   from the market. Cached per session. Also holds the finishing touches of the delivery timeline
   animation (both lines fill, the last dot grows and pulses). */
(function () {
  var KEY = 'ugc_visitor_country';
  var cc = null;
  var pending = false;
  try { cc = sessionStorage.getItem(KEY); } catch (error) {}

  var SHIPPING = /verzend|shipping|versand|livraison|env[ií]o|spedizione|dostaw/i;
  var SCOPES = ['announcement-bar', '.ugp-usps', '.ugc-top'];
  var SKIP = { SCRIPT: 1, STYLE: 1, IMG: 1, SVG: 1, BUTTON: 1, PATH: 1 };

  // Product page line. Dutch and English take a preposition ("naar Spanje", "to Spain"). The other languages
  // need an article or a declined country name ("vers l'Espagne", "do Hiszpanii"), which cannot be derived
  // safely, so they show the country in brackets instead ("Kostenloser Versand (Spanien) ab €60").
  var PREP = { nl: 'naar', en: 'to' };
  var THRESHOLD = /^([\s\S]*?\S)\s+(vanaf|from|ab|d[eè]s|desde|da|od)\b([\s\S]*)$/i;

  function injectStyles() {
    if (document.querySelector('style[data-ug-ship-flag]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-ug-ship-flag', '');
    style.textContent =
      '.ug-ship-flag{display:inline-block;width:18px;height:13px;margin-left:6px;vertical-align:-1px;border-radius:2px;object-fit:cover;box-shadow:0 0 0 1px rgba(0,0,0,.15)}' +
      '.ugd__top{flex-direction:row-reverse;justify-content:flex-end}' +
      /* timeline: step 1 dot, line 1 fills, step 2 dot, line 2 fills completely, last dot grows and pulses */
      '.ugd.is-live .ugd__step:nth-child(2) .ugd__line::after{width:100%!important;transition-delay:1.25s!important}' +
      '.ugd.is-live .ugd__step:nth-child(3) .ugd__dot,.ugd.is-live .ugd__step:nth-child(3) .ugd__label{transition-delay:2.2s!important}' +
      '.ugd__step--last .ugd__dot{flex:0 0 40px!important;width:40px!important;height:40px!important;margin:-4px 0 -4px -4px}' +
      '.ugd.is-live .ugd__step--last .ugd__dot{animation:ugdHalo 2.2s ease-out 2.9s infinite!important;box-shadow:0 0 0 5px rgba(11,11,11,.14)}' +
      '@keyframes ugdHalo{0%{box-shadow:0 0 0 5px rgba(11,11,11,.18)}70%{box-shadow:0 0 0 14px rgba(11,11,11,0)}100%{box-shadow:0 0 0 5px rgba(11,11,11,.18)}}' +
      '@media (prefers-reduced-motion:reduce){.ugd.is-live .ugd__step--last .ugd__dot{animation:none!important}}';
    document.head.appendChild(style);
  }

  function flagSrc() { return 'https://flagcdn.com/w40/' + cc.toLowerCase() + '.png'; }

  function makeFlag() {
    var img = document.createElement('img');
    img.className = 'ug-ship-flag';
    img.alt = '';
    img.width = 18;
    img.height = 13;
    img.setAttribute('src', flagSrc());
    img.onerror = function () { img.style.display = 'none'; };
    return img;
  }

  function pageLang() {
    return String(document.documentElement.lang || 'en').replace('_', '-').toLowerCase();
  }

  function countryName() {
    try {
      if (window.Intl && Intl.DisplayNames) return new Intl.DisplayNames([pageLang()], { type: 'region' }).of(cc) || cc;
    } catch (error) {}
    return cc;
  }

  // An element counts when one of its OWN text nodes mentions shipping (so "✓ Free shipping" inside a div works).
  function ownShippingTextNode(node) {
    var children = node.childNodes;
    for (var i = 0; i < children.length; i++) {
      if (children[i].nodeType === 3 && SHIPPING.test(children[i].textContent || '')) return children[i];
    }
    return null;
  }

  // Product page line: "Free shipping from €60" becomes "Free shipping to Spain from €60" (or with the
  // country in brackets). Returns false when the sentence has no threshold word.
  function nameCountry(node, textNode) {
    var match = THRESHOLD.exec(textNode.data);
    if (!match) return false;

    var prep = PREP[pageLang().slice(0, 2)];
    var name = countryName();
    var insert = prep ? prep + ' ' + name : '(' + name + ')';
    var leading = textNode.data.match(/^\s*/)[0];
    textNode.data = leading + match[1].replace(/^\s+/, '') + ' ' + insert + ' ' + match[2] + match[3];
    node.setAttribute('data-ug-ship-named', cc);
    return true;
  }

  function apply() {
    if (!cc) return;
    injectStyles();
    var src = flagSrc();

    SCOPES.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (scope) {
        var middle = selector === '.ugp-usps';
        scope.querySelectorAll('*').forEach(function (node) {
          if (SKIP[node.tagName.toUpperCase()]) return;
          if (node.hasAttribute('data-ug-ship-named')) return;

          var existing = node.querySelector(':scope > .ug-ship-flag');
          if (existing) {
            if (existing.getAttribute('src') !== src) existing.setAttribute('src', src);
            return;
          }

          var textNode = ownShippingTextNode(node);
          if (!textNode) return;

          if (middle) {
            if (!nameCountry(node, textNode)) node.setAttribute('data-ug-ship-named', cc);
            return;
          }
          node.appendChild(makeFlag());
        });
      });
    });
  }

  function resolve() {
    if (cc || pending) return;
    pending = true;
    fetch('/browsing_context_suggestions.json?country[enabled]=true&country[exclude]=ZZ&language[enabled]=false', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var detected = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (/^[A-Za-z]{2}$/.test(detected || '')) cc = detected.toUpperCase();
      })
      .catch(function () {})
      .then(function () {
        pending = false;
        if (cc) { try { sessionStorage.setItem(KEY, cc); } catch (error) {} }
        apply();
      });
  }

  var scheduled = false;
  function sync() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      if (cc) apply(); else resolve();
    }, 30);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
  if (window.MutationObserver) {
    new MutationObserver(sync).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }
})();
